import { OutlinedInput } from '@mui/material';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import { useEffect, useState } from 'react';
import GenerateCreateFieldChild from './GenerateCreateFieldChild';

type RadioFieldType = {
  option: any;
  position: number;
  idx: number;
  sx?: any;
  children_fields: any[];
  handleInputOptionChange: (event: any, idx: number, position: number) => void;
  removeOption: (idx: number, position: number) => void;
  handleInputChildQuestions: (value: any, position: number) => void;
};

const RadioField: React.FC<RadioFieldType> = (props) => {
  const [childQuestions, setChildQuestions] = useState<any>(
    props.children_fields || []
  );
  const [isAddChild, setIsAddChild] = useState(true);

  useEffect(() => {
    if (Array.isArray(props.children_fields)) {
      setChildQuestions(props.children_fields);

      let flagChild = true;
      props.children_fields.map((cf) => {
        if (cf.parent_id === props.idx) {
          flagChild = false;
        }
        return cf;
      });
      setIsAddChild(flagChild);
    }
  }, [props.children_fields, props.idx]);

  const handleAddChildQuestion = () => {
    setIsAddChild(false);
    let tempQues = [...childQuestions];
    const question = {
      type: 'text',
      label: '',
      help_text: '',
      field_id: '',
      min_length: '',
      max_length: '',
      required: false,
      order: 1,
      parent_id: props.idx,
    };
    tempQues.push(question);
    setChildQuestions(tempQues);
    props.handleInputChildQuestions(tempQues, props.position);
  };

  const handleChangeValue = (value: any, position: number) => {
    let tempQues = [...childQuestions];
    tempQues[position] = value;
    setChildQuestions(tempQues);
    props.handleInputChildQuestions(tempQues, props.position);
  };

  const removeQuestion = (position: number) => {
    let tempQues = [...childQuestions];
    tempQues.splice(position, 1);
    setChildQuestions(tempQues);
    props.handleInputChildQuestions(tempQues, props.position);
  };

  const handleModified = (order: number) => {};

  return (
    <Stack>
      <Stack direction={'row'} spacing={'4px'} mb={'4px'}>
        <OutlinedInput
          sx={{ ...props.sx }}
          inputProps={{
            sx: {
              backgroundColor: 'primary.light',
            },
          }}
          name={'option'}
          value={props.option}
          onChange={(event) =>
            props.handleInputOptionChange(event, props.idx, props.position)
          }
        />
        <Box
          component={'img'}
          src='/images/icons/ic-trash.svg'
          alt='trash'
          sx={{ cursor: 'pointer', width: '24px' }}
          onClick={() => props.removeOption(props.idx, props.position)}
        />
      </Stack>
      {childQuestions.map((question: any, index: number) => {
        if (question.parent_id !== props.idx) return <div key={index}></div>;
        return (
          <GenerateCreateFieldChild
            field={question}
            key={index}
            position={index}
            idxParent={props.idx}
            handleChangeValue={handleChangeValue}
            removeQuestion={removeQuestion}
            handleModified={handleModified}
          />
        );
      })}
      {isAddChild && (
        <BtnOutlineGradient
          text='子の質問を追加'
          handleButtonClick={handleAddChildQuestion}
          width='100px'
        />
      )}
      <Divider sx={{ my: '8px' }} />
    </Stack>
  );
};

export default RadioField;
